import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IMailTemplate, defaultValue } from '../../model/mail-template.model';

export const ACTION_TYPES = {
  FETCH_MAILTEMPLATE_LIST: 'mailTemplate/FETCH_MAILTEMPLATE_LIST',
  FETCH_MAILTEMPLATE: 'mailTemplate/FETCH_MAILTEMPLATE',
  CREATE_MAILTEMPLATE: 'mailTemplate/CREATE_MAILTEMPLATE',
  UPDATE_MAILTEMPLATE: 'mailTemplate/UPDATE_MAILTEMPLATE',
  DELETE_MAILTEMPLATE: 'mailTemplate/DELETE_MAILTEMPLATE',
  RESET: 'mailTemplate/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IMailTemplate>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type MailTemplateState = Readonly<typeof initialState>;

// Reducer

export default (state: MailTemplateState = initialState, action): MailTemplateState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MAILTEMPLATE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MAILTEMPLATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_MAILTEMPLATE):
    case REQUEST(ACTION_TYPES.UPDATE_MAILTEMPLATE):
    case REQUEST(ACTION_TYPES.DELETE_MAILTEMPLATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_MAILTEMPLATE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MAILTEMPLATE):
    case FAILURE(ACTION_TYPES.CREATE_MAILTEMPLATE):
    case FAILURE(ACTION_TYPES.UPDATE_MAILTEMPLATE):
    case FAILURE(ACTION_TYPES.DELETE_MAILTEMPLATE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MAILTEMPLATE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_MAILTEMPLATE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_MAILTEMPLATE):
    case SUCCESS(ACTION_TYPES.UPDATE_MAILTEMPLATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_MAILTEMPLATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/mail-templates';

// Actions

export const getEntities: ICrudGetAllAction<IMailTemplate> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_MAILTEMPLATE_LIST,
    payload: axios.get<IMailTemplate>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IMailTemplate> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_MAILTEMPLATE,
    payload: axios.get<IMailTemplate>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IMailTemplate> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MAILTEMPLATE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IMailTemplate> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MAILTEMPLATE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IMailTemplate> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MAILTEMPLATE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
